interface DateDisplayCardProps {
    dateLabel: string;
    dateDisplay: string;
}

const DateDisplayCard = ({ dateLabel, dateDisplay }: DateDisplayCardProps) => {
    // Function to break long words with hyphens
    const formatLabel = (label: string) => {
        if (label.length <= 6) {
            return label;
        }
        
        // For words longer than 6 characters, break them intelligently
        if (label.toLowerCase() === 'yesterday') {
            return 'Yester-\nday';
        }
        
        // Generic breaking for other long words
        const breakPoint = Math.ceil(label.length / 2);
        return `${label.substring(0, breakPoint)}-\n${label.substring(breakPoint)}`;
    };

    const formattedLabel = formatLabel(dateLabel);
    
    return (
        <div className="flex w-[73px] shrink-0">
            <div className="w-[70px] bg-grey-95 dark:bg-primary-90 flex h-full flex-col items-center justify-center rounded-lg p-2.5">
                <p className="dark:text-primary-40 font-semibold text-center leading-tight whitespace-pre-line">
                    {formattedLabel}
                </p>
                <p className="dark:text-primary-40 text-sm font-semibold">{dateDisplay}</p>
            </div>
        </div>
    );
};

export default DateDisplayCard;